module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8543/img/spinner.png"